type PropsType = {

}

const Settings: React.FC<PropsType> = (props) => {
    return (
        <div>
            Settings
        </div>
    );
}

export default Settings;